function NormalExpenseInput({
  expenseText,
  setExpenseText,
  addExpense,
  loading,
  disabled = false
}) {
  return (
    <div className="input-box">
      <h3>Manual Entry</h3>

      <div className="input-row">
        <input
          value={expenseText}
          onChange={(e) => setExpenseText(e.target.value)}
          placeholder="200 biryani 50 milk"
          disabled={disabled}
        />

        <button onClick={addExpense} disabled={loading || disabled}>
          {loading ? "Adding..." : "Add"}
        </button>
      </div>
    </div>
  );
}

export default NormalExpenseInput;
